import React, {useMemo} from 'react';
import {Navigate, Outlet, useLocation} from "react-router-dom";
import {useAuth} from "../../providers/AuthProvider";
import {Helmet} from "react-helmet";

const ClientLayout = props => {

    const {auth} = useAuth();
    const location = useLocation()
    const clientName = useMemo(() => auth.clientOrg()?.name, [auth?.client_organization?.name]);

    if (auth && !auth.isClient() && !auth.canManageClients()) {
        return <Navigate to={TB.auth().appropriate()} state={{ from: location }} replace />;
    }

    if (auth && location.pathname !== '/client/org/select-organization' && auth.isClientConsultant() && !auth.hasClientOrg()) {
        return <Navigate to={'/client/org/select-organization'} state={{ from: location }} replace />;
    }

    if (auth && location.pathname !== '/client/org/registration'
        && (auth.isClient() || auth.canManageClients())
        && auth.hasClientOrg()
        && !auth.hasRegisteredClientOrg()) {
        return <Navigate to={'/client/org/registration'} state={{ from: location }} replace />;
    }

    if (auth && location.pathname === '/client/org/registration'
        && (auth.isClient() || auth.canManageClients())
        && auth.hasClientOrg()
        && auth.hasRegisteredClientOrg()) {
        return <Navigate to={TB.auth().appropriate()} state={{ from: location }} replace />;
    }

    return (
        <React.Fragment>
            {clientName && (
                <Helmet>
                    <title>{clientName} | Wripple</title>
                </Helmet>
            )}
            <Outlet/>
        </React.Fragment>
    );
};

ClientLayout.propTypes = {

};

export default ClientLayout;